export default __webpack_public_path__ + "youtube-logo-2.png";